import { navigate } from "@reach/router"
import { usePolicyAndFleet } from "../../../contexts"
import { ResolvedFleetEntry } from "../../../api/fleet"
import { useChangedAndUnchangedEntries } from "../../confirmChanges/hooks/useChangedAndUnchangedEntries"
import { resolveCoverPeriods } from "../utils/resolveCoverPeriods"
import { ConfirmFleetEntryChanges } from "../../confirmChanges/ConfirmFleetEntryChanges"

type Props = {
  dataTestId: string
  entries: ReadonlyArray<ResolvedFleetEntry>
  onConfirmed: () => void
  onBack: () => void
}
export const ConfirmAddFleetEntries = ({ dataTestId, entries, onBack, onConfirmed }: Props) => {
  const { fleet } = usePolicyAndFleet()

  const fleetData = fleet.data || []

  const { changedEntries, unchangedEntries } = useChangedAndUnchangedEntries(
    fleetData,
    resolveCoverPeriods([...fleetData, ...entries]),
    entries.map((it) => it.registrationNumber)
  )

  return (
    <ConfirmFleetEntryChanges
      dataTestId={dataTestId}
      changedEntries={changedEntries}
      unchangedEntries={unchangedEntries}
      onConfirmed={onConfirmed}
      onBack={onBack}
      onCancel={() => navigate(`fleet`)}
    />
  )
}
